module.exports = __webpack_public_path__ + "img/logo.362bd053.png";